var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{staticClass:"align-items-center p-5 card-spinner"},[_c('CSpinner',{staticStyle:{"width":"10rem","height":"10rem"},attrs:{"color":"info","size":"lg"}},[_vm._v(" Loading... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }